import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import { SHOPIFY_APP_STORE_URL } from "./constants";

/** Marketing-site footer with brand mark + nav + legal links. */
export const Footer = () => (
  <footer
    data-testid="landing-footer"
    className="px-6 md:px-10 py-12 border-t border-slate-200 pb-[calc(3rem+env(safe-area-inset-bottom)+72px)] md:pb-12"
  >
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="AI Growth Operator" className="w-8 h-8 rounded-md object-contain" />
        <div>
          <div className="text-slate-900 text-sm font-bold tracking-tight">AI Growth Operator</div>
          <div className="text-slate-500 text-[11px] mt-0.5">© {new Date().getFullYear()} · Autonomous revenue for Shopify</div>
        </div>
      </div>
      <div className="flex items-center gap-4 md:gap-6 text-sm text-slate-600 flex-wrap">
        <Link to="/demo" data-testid="footer-demo" className="hover:text-slate-900 transition">Overview</Link>
        <a href="#pricing" className="hover:text-slate-900 transition">Pricing</a>
        <Link to="/privacy" data-testid="footer-privacy" className="hover:text-slate-900 transition">Privacy</Link>
        <Link to="/terms" data-testid="footer-terms" className="hover:text-slate-900 transition">Terms</Link>
        <a
          href={SHOPIFY_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-app-store"
          className="inline-flex items-center gap-1 text-emerald-700 hover:text-emerald-800 font-semibold"
        >
          Shopify App Store <ArrowUpRight className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
    <div
      data-testid="footer-metrics-disclaimer"
      className="max-w-7xl mx-auto mt-8 pt-6 border-t border-slate-100 text-[11px] leading-relaxed text-slate-400 italic"
    >
      *Indicative metrics only — outputs depend on many inputs.
    </div>
  </footer>
);

/** Sticky bottom CTA on mobile only — appears after the user scrolls past the hero. */
export const StickyMobileCta = ({ visible, dismissed, onDismiss }) => {
  if (!visible || dismissed) return null;
  return (
    <div
      data-testid="mobile-bottom-cta"
      className="md:hidden fixed inset-x-0 bottom-0 z-[55] px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-8px_24px_-12px_rgba(15,23,42,0.18)]"
      style={{ animation: "lift 280ms cubic-bezier(.2,.8,.2,1) both" }}
    >
      <div className="flex items-center gap-2">
        <a
          href={SHOPIFY_APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bottom-cta-install"
          className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full bg-emerald-500 active:bg-emerald-600 text-white text-sm font-bold shadow-lg shadow-emerald-500/30"
        >
          Install free on Shopify · 60 sec <ArrowUpRight className="w-4 h-4" />
        </a>
        <button
          data-testid="mobile-bottom-cta-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss install banner"
          className="shrink-0 w-10 h-10 rounded-full border border-slate-200 bg-white text-slate-500 active:text-slate-900 text-xl leading-none"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Footer;
